// extracted by mini-css-extract-plugin
export default {"scrollBody":"J7D2QOFh","modalBody":"haPWLe8c","contentRow":"DDDBs4Zr","contentMain":"GK3Gb1nt","tableArea":"FGoPyF7k","sidebar":"Mjf8xxJD"};